export default [
  {
    title: 'breadcrumb.result',
    route: 'result',
    icon: '',
    resource: 'result',
    action: 'read',
  }
];